module.exports = __webpack_public_path__ + "img/gy_img3.58c230b2.png";